import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Políticas e Termos de Uso ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Política de Privacidade ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Termos de Uso ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Política de Trocas e Devoluções ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Perguntas Frequentes ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_PinchScrollZoom = _resolveComponent("PinchScrollZoom")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_modal, {
        onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenCard=false)),
        "is-open": _ctx.isOpen
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SafeArea, {
            onOnBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOpen(false))),
            data: {'cart': false}
          }),
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_PinchScrollZoom, {
                ref: "zoomer",
                width: 600,
                height: 800,
                scale: 1,
                originX: 0,
                originY: 0,
                translateX: 0,
                translateY: 0,
                within: false,
                enableDragging: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "8" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", { innerHTML: _ctx.termos }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                class: "font-poppins-extra font-20 ion-text-center",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, {
                class: "menu-itens",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getPrivacidade()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        class: "ion-icon",
                        slot: "start",
                        icon: _ctx.iconPolitc
                      }, null, 8, ["icon"]),
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getTermos()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        class: "ion-icon",
                        slot: "start",
                        icon: _ctx.iconTermos
                      }, null, 8, ["icon"]),
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getTrocas()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        class: "ion-icon",
                        slot: "start",
                        icon: _ctx.iconTrocas
                      }, null, 8, ["icon"]),
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getFaq()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        class: "ion-icon",
                        slot: "start",
                        icon: _ctx.iconFaq
                      }, null, 8, ["icon"]),
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}